import { render, staticRenderFns } from "./RowItemChatgpt.vue?vue&type=template&id=dcf7ca2c&scoped=true&"
import script from "./RowItemChatgpt.vue?vue&type=script&lang=js&"
export * from "./RowItemChatgpt.vue?vue&type=script&lang=js&"
import style0 from "./RowItemChatgpt.vue?vue&type=style&index=0&id=dcf7ca2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcf7ca2c",
  null
  
)

/* custom blocks */
import block0 from "./RowItemChatgpt.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports